
export const NotificationGroupsEnum = {
    WITH_BIRTHDAY: 'WITH_BIRTHDAY',
    ALL_USERS: 'ALL',
    NOT_ATTENDED_LAST_3_GAMES: 'NOT_ATTENDED_LAST_3_GAMES',
    NOT_ATTENDED_LAST_5_GAMES: 'NOT_ATTENDED_LAST_5_GAMES',
    SEASON_TICKET_HOLDERS: 'SEASON_TICKET_HOLDERS',
    NON_SEASON_TICKET_HOLDERS: 'NON_SEASON_TICKET_HOLDERS',
};